//dependencias
import React, { Component } from 'react';

//componentes
import AutorizarAdecuaciones from './autorizarAdecua'

class Index extends Component {

    render(){
        return(
            <div>
                <AutorizarAdecuaciones />
            </div>
        );
    }

}
export default Index;